import { render, staticRenderFns } from "./RecipeNotes.vue?vue&type=template&id=49f8ddd2"
import script from "./RecipeNotes.vue?vue&type=script&lang=js"
export * from "./RecipeNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports